import { useListagemContext } from 'context/ListagemContext';
import { FilterValuesProps } from 'hooks/useFilter';

export function useDreFilterLojas(): FilterValuesProps | undefined {
    const { fullFilterData } = useListagemContext();
    const filterLoja = fullFilterData?.find((filter) => filter.value.property === 'idLoja');

    return filterLoja?.value;
}
